export const INSIGHT_DETAIL = {
  LEVEL: 'Nivel de criticidad',
  DESCRIPTION: 'Descripción',
  AFFECTED_RESOURCES: 'Recursos afectados',
  AFFECTED_USERS: 'Usuarios afectados',
  PERCENTAGE: 'Porcentaje',
  RECOMMENDED_ACTIONS: 'Acciones recomendadas',
  USERS: 'Usuarios',
}

export const INSIGHT_CRITICALITY_LEVEL = {
  low: 'Bajo',
  medium: 'Medio',
  high: 'Alto',
  critical: 'Crítico',
}
